<template>
	<div id="app">

		<header class="navbar-fixed">
			<nav class="white hide-on-large-only">
				<div class="nav-wrapper">
					<a class="brand-logo">
						<img src="@/assets/logo-large.png" alt="human express" class="logo-navbar-img">
					</a>
					<a href="#" data-target="slide-out" class="sidenav-trigger left"><i class="material-icons green-text">menu</i></a>
				</div>
			</nav>

			  <div class="navbar-fixed hide-on-med-and-down">
					<nav class="white">
					<div style="margin:">
							<div class="nav-wrapper left-align">
							<a class="brand-logo">
								<img src="@/assets/logo-large.png" alt="human express" class="logo-navbar-img">
							</a>
							<ul class="right hide-on-med-and-down">
								<li v-for="(page, index) in pages" :key="index">
									<router-link :to="'/' + page.title.replace(/ /g, '-')" class=" grey-text text-darken-2">
										<i class="material-icons indigo-text left">{{ page.icon }} </i> {{ page.title }}
									</router-link>
								</li>
							</ul>
						</div>
					</div>
					</nav>
				</div>
		</header>

		<ul id="slide-out" class="sidenav left-align white">
			<li style="padding: 5px" class="center li-logo hide-on-med-and-down">
				<img src="@/assets/logo-large.png" class="logo" onclick="location.href=''">
				<p class="grey-text text-darken-3" style="line-height : normal">
					<i>Consultoría especializada en <br>recursos humanos</i>
				</p>
			</li>
			<li v-for="(page, index) in pages" :key="index">
				<router-link :to="'/' + page.title.replace(/ /g, '-')" class="sidenav-close grey-text text-darken-2">
					<i class="material-icons indigo-text">{{ page.icon }} </i> {{ page.title }}
				</router-link>
			</li>
		</ul>

		<main>
			<div class="card-content-page">
				<router-view />
			</div>
		</main>

		<footer class="page-footer grey lighten-4">
			<div class="container">
				<div class="row">
					<div class="col l6 s12">
						<h5 class="grey-text text-darken-3">Consultoría especializada en Recursos Humanos</h5>
					</div>
					<div class="col l6 s12">
						
							<a style="font-size:25px" class="grey-text text-darken-3" href="https://www.facebook.com/Humanexpress">
								<i class="fa fa-facebook-square"></i> 
							</a>

							<a style="font-size:25px" class="grey-text text-darken-3" href="https://www.facebook.com/humanexpresstijuana/">
								<i class="fa fa-facebook-square"></i> 
							</a>

							<a style="font-size:25px" class="grey-text text-darken-3" href="https://www.linkedin.com/in/human-express-consultor%C3%ADa-b921118a/">
								<i class="fa fa-linkedin-square"></i> 
							</a>

							<a style="font-size:25px" class="grey-text text-darken-3" href="https://twitter.com/humanexpress?lang=en">
								<i class="fa fa-twitter-square"></i> 
							</a>

							<div class="left-align" style="font-size:1.5rem">
								<div class="subheader grey-text">
									<div class="material-icons" style="font-size:1.5rem">email</div>	
									<span>Directorio</span>
								</div>
							</div>

							<ul class="left-align">
								<li class="grey-text text-darken-3">
									Ventas: <a class="blue-text text-darken-3" href="mailto:promocionyventas@human-express.com">promocionyventas@human-express.com</a>
								</li>
								<li class="grey-text text-darken-3">
									Atracción de Talento: <a class="blue-text text-darken-3" href="mailto:atracciondetalento@human-express.com">atracciondetalento@human-express.com</a>
								</li>
								<li class="grey-text text-darken-3">
									Clientes: <a class="blue-text text-darken-3" href="mailto:clientes@human-express.com">clientes@human-express.com</a>
								</li>
									<li class="grey-text text-darken-3">
									Facturación: <a class="blue-text text-darken-3" href="mailto:facturacion@human-express.com">facturacion@human-express.com</a>
								</li>
							</ul>
					</div>
				</div>
			</div>
			<div class="footer-copyright">
				<div class="container grey-text text-darken-3">
					© 2011-2018 Human Express
					<a class="grey-text text-darken-3 right">Oficina: 01 (664) 545-07-19 Móvil: 044 (664) 123-71-79</a>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import axios from "axios";
import sideNav from "@/assets/js/materialize";
import verify from "@/assets/js/verify";
sideNav();

export default {
  name: "App",
  data() {
    return {
      pages: []
    };
  },
  methods: {
    getData() {
      console.log(this.$route.params.name);
      axios
        .get("/php/pages/read.php?pageQuery=*")
        .then(response => {
          console.log(response.data);
          this.pages = response.data.pages;
        })
        .catch(error => {
          M.toast({
            html: "Ha ocurrido un error"
          });
          console.log(error);
          this.pre = false;
        });
    }
  },
  mounted() {
    this.getData();
    verify();
  }
};
</script>

<style>
@import "/assets/css/admin.css";
@import "/assets/css/app.css";

#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue